import formBaseMongo from '../../../components/form/form-base-mongo.js'
import {APPEAL_CATS, APPEAL_STATUSES, ROOT_API} from '../../../config/config'

export default {
  mixins: [formBaseMongo],
  data () {
    return {
      tabView: 'tab1',
      fields: {
        answers: [],
        photos: [],
        latitude: '',
        longitude: ''
      }
    }
  },
  computed: {
    answerStatuses () {
      return APPEAL_STATUSES
    },
    appealCategories () {
      return APPEAL_CATS
    },
    uploadedPhotosUrls () {
      const imageFields = ['appeal_file', 'appeal_file_2', 'appeal_file_3']
      const imageUrls = []

      for (let fName of imageFields) {
        if (this.fields[fName]) {
          /*created_at: null
ext: "png"
id: 1628
name: "image_2019-08-14_12-38-09.png"
size: 9481
url: "core/file/1628/image_2019-08-14_12-38-09.png"
user_email: "dem0@test.ru"
user_id: 44*/
          const url = ROOT_API + this.fields[fName].url
          imageUrls.push(url)
        }
      }

      return imageUrls
    }
  },
  methods: {
    // for demo only
    addPhoto () {
      if (!this.fields.photos) {
        this.$set(this.fields, 'photos', [])
      }
      this.fields.photos.push('')
    },
    afterPrepareFieldsForSend (fields = {}) {
      let fDeepCopy = JSON.parse(JSON.stringify(fields))
      if (fDeepCopy.answer_description) {
        if (!fDeepCopy.answers) {
          fDeepCopy.answers = []
        }
        let data = {
          answer_description: fDeepCopy.answer_description,
          answer_file: fDeepCopy.answer_file,
          answered_at: this.$options.filters.unixTimeToDate(
            +new Date(),
            'DD.MM.YYYY'
          )
        }
        fDeepCopy.answer_description = ''
        fDeepCopy.answer_file = {}
        fDeepCopy.answers.push(data)
        fDeepCopy.answered_at = data.answered_at
      }
      return fDeepCopy
    }
  },
  asyncData ({store, route, fromRoute, methods}) {
    let promises = []
    if (methods.getItemEndpoint(route, fromRoute) !== null) {
      promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getItemEndpoint(route, fromRoute)}))
    }

    if (promises.length === 0) {
      return Promise.resolve(1)
    }

    return Promise.all(promises)
  }
}
